import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const CATEGORIES = [
  {
    id: 'banking',
    icon: '🏦',
    title: 'Banking & Money',
    desc: 'Open an AU bank account, get a debit card, send money home',
    links: [
      { label: 'Open a bank account (no passport needed)', url: 'https://www.commbank.com.au/bank-accounts/no-credit-check.html', note: 'Commonwealth Bank · Easy to open' },
      { label: 'Compare bank accounts for newcomers', url: 'https://www.finder.com.au/bank-accounts', note: 'Finder.com.au · Compare fees & features' },
      { label: 'Send money overseas cheap', url: 'https://wise.com/au/', note: 'Wise (formerly TransferWise) · Real exchange rates' },
      { label: 'Get a credit card to build history', url: 'https://www.canstar.com.au/credit-cards/', note: 'Canstar · Compare low-fee cards' },
    ],
  },
  {
    id: 'tax',
    icon: '🧾',
    title: 'Tax & Super',
    desc: 'Get your TFN, file taxes, set up superannuation',
    links: [
      { label: 'Apply for a TFN (Tax File Number)', url: 'https://www.ato.gov.au/individuals/tax-file-number/apply-for-a-tfn/', note: 'ATO · Free · Required to work legally' },
      { label: 'Choose a super fund', url: 'https://www.australiansuper.com/', note: 'AustralianSuper · Industry leader' },
      { label: 'File your first tax return', url: 'https://www.ato.gov.au/individuals/your-tax-return/', note: 'ATO · Free via myGov' },
      { label: 'Check your super balance', url: 'https://www.ato.gov.au/individuals/super/keeping-track-of-your-super/', note: 'ATO · Track lost super' },
    ],
  },
  {
    id: 'visa',
    icon: '🛂',
    title: 'Visa & Right to Work',
    desc: 'Check your visa conditions, extend stay, apply for PR',
    links: [
      { label: 'Check your visa online (VEVO)', url: 'https://vevo.homeaffairs.gov.au/', note: 'Home Affairs · Free · Instant' },
      { label: 'Find the right visa for you', url: 'https://candidate.workinaus.com.au/', note: 'WorkInAus · Free assessment' },
      { label: 'Visa medical exams', url: 'https://www.bupamvs.com.au/', note: 'Bupa MVS · Book online' },
      { label: 'Partner/Spouse visa help', url: 'https://www.migrationinstitute.org/', note: 'Migration Institute · Accredited agents' },
    ],
  },
  {
    id: 'housing',
    icon: '🏠',
    title: 'Housing & Rentals',
    desc: 'Find a place to live, understand your tenant rights',
    links: [
      { label: 'Find rentals on Realestate.com.au', url: 'https://www.realestate.com.au/rent', note: 'Largest rental platform' },
      { label: 'Find share houses & flatmates', url: 'https://flatmates.com.au/', note: 'Flatmates.com.au · Room listings' },
      { label: 'Rental bond & tenant rights', url: 'https://www.tenants.org.au/', note: 'Tenants Union · Know your rights' },
    ],
  },
  {
    id: 'health',
    icon: '🏥',
    title: 'Health & Insurance',
    desc: 'Medicare, private health, ambulance cover',
    links: [
      { label: 'Apply for Medicare (if eligible)', url: 'https://www.servicesaustralia.gov.au/medicare', note: 'Services Australia · Free basic cover' },
      { label: 'Compare health insurance', url: 'https://www.comparethemarket.com.au/health-insurance/', note: 'Compare the Market · Easy switch' },
      { label: 'Ambulance cover (essential!)', url: 'https://www.ambulancecover.com.au/', note: 'Ambulance Victoria · Very affordable' },
      { label: 'Find a bulk-billing GP', url: 'https://www.healthdirect.gov.au/', note: 'HealthDirect · Free doctor finder' },
    ],
  },
  {
    id: 'phone',
    icon: '📱',
    title: 'Phone & Internet',
    desc: 'Get a SIM plan, home internet, mobile data',
    links: [
      { label: 'Prepaid SIM plans (no credit check)', url: 'https://www.aldimobile.com.au/', note: 'ALDI Mobile · Great value, no lock-in' },
      { label: 'Compare phone plans', url: 'https://www.whistleout.com.au/MobilePhones', note: 'WhistleOut · Compare 50+ plans' },
      { label: 'Budget home internet', url: 'https://www.tpg.com.au/', note: 'TPG · Affordable NBN plans' },
    ],
  },
  {
    id: 'transport',
    icon: '🚗',
    title: 'Transport & Driving',
    desc: 'Get an AU licence, buy a car, public transport',
    links: [
      { label: 'Convert your overseas licence', url: 'https://www.service.nsw.gov.au/transaction/transfer-overseas-driver-licence', note: 'Service NSW · Must do within 3 months' },
      { label: 'Buy a used car', url: 'https://www.carsales.com.au/', note: 'Carsales · Search by budget & location' },
      { label: 'Public transport cards', url: 'https://www.opal.com.au/', note: 'Opal (NSW) · Tap on/off' },
      { label: 'Car insurance comparison', url: 'https://www.comparethemarket.com.au/car-insurance/', note: 'Compare the Market · Save $100s' },
    ],
  },
  {
    id: 'education',
    icon: '📚',
    title: 'Study & Skills',
    desc: 'Free TAFE courses, English classes, skill assessments',
    links: [
      { label: 'Free English classes (AMEP)', url: 'https://www.homeaffairs.gov.au/amep', note: '510 hours free English · Government funded' },
      { label: 'Free TAFE short courses', url: 'https://www.tafensw.edu.au/free-courses', note: 'TAFE NSW · In-demand skills' },
      { label: 'Have overseas qualifications assessed', url: 'https://www.qualificationsrecognition.com.au/', note: 'Qualifications Recognition · Free assessment' },
    ],
  },
  {
    id: 'legal',
    icon: '⚖️',
    title: 'Legal & Rights',
    desc: 'Workplace rights, free legal help, community support',
    links: [
      { label: 'Know your workplace rights', url: 'https://www.fairwork.gov.au/', note: 'Fair Work Ombudsman · Free advice' },
      { label: 'Free legal help', url: 'https://www.legalaid.nsw.gov.au/', note: 'Legal Aid NSW · Free for eligible' },
      { label: 'Community legal centres', url: 'https://www.clcnsw.org.au/', note: 'CLC NSW · Free advice clinics' },
      { label: 'Report wage theft', url: 'https://www.fairwork.gov.au/how-we-will-help/templates-and-guides/report-an-issue', note: 'Fair Work · Anonymous reports' },
    ],
  },
  {
    id: 'community',
    icon: '🤝',
    title: 'Community & Support',
    desc: 'Find your community, migrant support groups, food & crisis help',
    links: [
      { label: 'Migrant Resource Centres', url: 'https://www.mrcnsw.org.au/', note: 'MRC NSW · Free settlement support' },
      { label: 'Find food & financial help', url: 'https://www.askizzy.org.au/', note: 'Ask Izzy · Find help near you' },
      { label: 'Lifeline — 24/7 crisis support', url: 'https://www.lifeline.org.au/', note: '13 11 14 · Free, confidential' },
      { label: 'SBS settlement guide', url: 'https://www.sbs.com.au/language/settlement-guide', note: 'SBS · Multi-language guides' },
    ],
  },
];

export default function MigrantHubPage() {
  const [search, setSearch] = useState('');
  const [activeCat, setActiveCat] = useState(null);

  const filtered = CATEGORIES.filter(cat =>
    !search ||
    cat.title.toLowerCase().includes(search.toLowerCase()) ||
    cat.desc.toLowerCase().includes(search.toLowerCase()) ||
    cat.links.some(l => l.label.toLowerCase().includes(search.toLowerCase()))
  ).map(cat => ({
    ...cat,
    links: search ? cat.links.filter(l =>
      l.label.toLowerCase().includes(search.toLowerCase())
    ) : cat.links,
  }));

  return (
    <div className="min-h-screen bg-neutral-50">
      <div className="max-w-3xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="text-5xl mb-3">🌏</div>
          <h1 className="text-3xl font-bold text-neutral-900 mb-2">Migrant Worker Hub</h1>
          <p className="text-neutral-500 max-w-lg mx-auto">
            Everything you need to settle, work, and thrive in Australia. Curated resources for newcomers — 
            with exclusive affiliate discounts to help you save.
          </p>
        </div>

        {/* Search */}
        <div className="relative mb-6 max-w-md mx-auto">
          <input
            type="text"
            placeholder="Search resources (e.g. TFN, bank account, visa)..."
            value={search}
            onChange={e => { setSearch(e.target.value); setActiveCat(null); }}
            className="w-full pl-10 pr-4 py-3 bg-white border border-neutral-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-brand-500/30 focus:border-brand-500"
          />
          <svg className="absolute left-3 top-3.5 w-5 h-5 text-neutral-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>

        {/* Quick links banner */}
        <div className="bg-gradient-to-r from-brand-500 to-brand-600 rounded-2xl p-5 mb-8 text-white">
          <p className="text-sm font-semibold mb-1">⚡ Most used by new arrivals</p>
          <div className="flex flex-wrap gap-2 mt-2">
            {['TFN', 'Bank Account', 'VEVO Check', 'Tax Return', 'Medicare'].map(q => (
              <button key={q} onClick={() => setSearch(q)}
                className="text-xs px-3 py-1.5 bg-white/20 hover:bg-white/30 rounded-full font-medium transition">
                {q}
              </button>
            ))}
          </div>
        </div>

        {/* Category grid */}
        {!activeCat ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
            {filtered.map(cat => (
              <button key={cat.id} onClick={() => setActiveCat(cat.id)}
                className="bg-white rounded-2xl border border-neutral-100 shadow-sm p-5 text-left hover:border-brand-200 hover:shadow-md transition group">
                <div className="text-3xl mb-2">{cat.icon}</div>
                <h3 className="font-bold text-neutral-900 group-hover:text-brand-600 transition mb-1">{cat.title}</h3>
                <p className="text-xs text-neutral-500 mb-3">{cat.desc}</p>
                <span className="text-xs text-brand-500 font-semibold">{cat.links.length} resources →</span>
              </button>
            ))}
          </div>
        ) : (
          /* Category detail view */
          <div>
            {filtered.filter(c => c.id === activeCat).map(cat => (
              <div key={cat.id}>
                <button onClick={() => setActiveCat(null)}
                  className="inline-flex items-center gap-2 text-sm text-neutral-500 hover:text-brand-600 mb-4 transition">
                  ← Back to all categories
                </button>
                <div className="bg-white rounded-2xl border border-neutral-100 shadow-sm p-6 mb-8">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-4xl">{cat.icon}</span>
                    <div>
                      <h2 className="text-xl font-bold text-neutral-900">{cat.title}</h2>
                      <p className="text-sm text-neutral-500">{cat.desc}</p>
                    </div>
                  </div>

                  <div className="space-y-3">
                    {cat.links.map((link, i) => (
                      <a key={i} href={link.url} target="_blank" rel="noopener noreferrer"
                        className="flex items-start gap-3 p-4 rounded-xl border border-neutral-100 hover:border-brand-200 hover:bg-brand-50 transition group">
                        <div className="mt-0.5">
                          <div className="flex items-center gap-2">
                            <span className="font-semibold text-neutral-900 text-sm group-hover:text-brand-700 transition">{link.label}</span>
                            <svg className="w-3.5 h-3.5 text-neutral-300 group-hover:text-brand-500 transition" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                            </svg>
                          </div>
                          <p className="text-xs text-neutral-400 mt-0.5">{link.note}</p>
                        </div>
                      </a>
                    ))}
                  </div>

                  {/* Affiliate disclosure */}
                  <p className="text-[10px] text-neutral-300 mt-4 text-center">
                    Some links are affiliate links. ShiftMatch may earn a small commission at no extra cost to you. 
                    We only recommend services we trust.
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Affiliate disclosure footer */}
        <div className="text-center text-xs text-neutral-400 space-y-2 mb-8">
          <p>
            🌏 The Migrant Worker Hub is built for newcomers to Australia. 
            All resources are vetted and updated regularly.
          </p>
          <p>
            💰 ShiftMatch earns commissions through affiliate partnerships with some of the services listed above.
            This helps us keep the platform free for workers.
          </p>
          <p className="text-neutral-300">
            Got a resource suggestion? Let us know. 🇦🇺
          </p>
        </div>

        {/* Back to dashboard */}
        <div className="text-center">
          <Link to="/worker" className="inline-flex items-center gap-2 text-sm text-brand-500 hover:text-brand-600 font-semibold transition">
            ← Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
